import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid2';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import Image from 'next/image';
import Typography from '../Typography';
import Loader from '../Loader';
import ChevronRight from '../Svg/ChevronRight';
import truncateString from '../../utils/truncate';
import Filters from '../Filters/Filters';
import urls from '../../utils/urls';

const ProductGrid = ({
  headline,
  pagination,
  products,
  filters,
  selectedFilters,
  locale,
}) => {
  const [loading, setLoading] = useState(false);
  const numFiltersWithProducts = filters?.filter((f) => { return f.count > 0; })?.length;

  // translations
  const t = useTranslations('Subcategories');

  // Generates a product card's markup
  const getProductCard = (product, i) => {
    const url = `${urls.product}${product.slug}/`;
    return (
      <Grid size={{ sm: 12, md: 6, lg: 4 }} key={product.thumbnail} itemProp="itemListElement" itemScope itemType="https://schema.org/Product">
        <Link href={url} prefetch={false} className="product-card" itemProp="url">
          {product?.thumbnail && (
            <div className="image-container">
              <Image
                alt={product.name}
                aria-hidden="true"
                className="image"
                fill
                itemProp="image"
                priority={i === 0}
                src={product.thumbnail}
                sizes="(max-width: 768px) 100vw,
                      (max-width: 1200px) 50vw,
                      33vw"
              />
            </div>
          )}
          {product.name && (
            <div className="name">
              <Typography itemProp="name" htmlTagOverride="h2" variant="heading-600">{truncateString(product.name, 35)}</Typography>
            </div>
          )}
          <div className="cta">
            <Typography variant="small">{t('card.cta')}</Typography>
            <ChevronRight width={16} height={16} fill="#78757E" />
          </div>
        </Link>
      </Grid>
    );
  };

  return (
    <div className="product-grid">
      <div className="product-grid-container">
        {!loading && headline && (<Typography variant="heading-700" addClasses="headline" htmlTagOverride="h1">{`${headline}`}</Typography>)}

        {/* Loading indicator and title */}
        {loading && (
          <Typography variant="heading-700" addClasses="headline" htmlTagOverride="h1">
            <Loader
              addClasses="products-loading"
              width="24px"
              height="24px"
            />
            {t('filters.loadingMessage')}
          </Typography>
        )}

        {/* Don't show the filters menu if there is only one filter
            or if only one filter has products under it */}
        {!!filters?.length && !!numFiltersWithProducts && (
          <Filters
            data={filters}
            selectedFilters={selectedFilters}
            loading={loading}
            setLoading={setLoading}
            locale={locale}
          />
        )}

        {/* eslint-disable-next-line no-console */}
        {console.log('products.length:', products?.length)}
        {!!products?.length && (
          <div
            className="grid-container"
            itemScope
            itemType="https://schema.org/ItemList"
          >
            <Grid container alignItems="stretch" spacing={{ xs: 2, md: 3 }}>
              {products?.map((product, i) => {
                // eslint-disable-next-line no-console
                console.log('product:', product);
                return getProductCard(product, i);
              })}
            </Grid>
            {pagination}
          </div>
        )}
      </div>
    </div>
  );
};

ProductGrid.propTypes = {
  headline: PropTypes.string.isRequired,
  pagination: PropTypes.node.isRequired,
  products: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  filters: PropTypes.array,
  selectedFilters: PropTypes.array,
  locale: PropTypes.string,
};

export default ProductGrid;
